import styled from "styled-components";

export const CategoryWrapper = styled.section.attrs({
    id: "category",
  })`
     padding:0 0.6rem;
  
      @media screen and (max-width: 1024px) {
        width: 100%;
       
      }
      @media screen and (min-width: 1024px) {
        width: 100%;
       
      }
      @media screen and (max-width: 600px) {
        width: var(--container-width-sm);
       
      }
      @media screen and (max-width: 280px) {
        width: var(--container-width-xsm);
       
      }
    
  




`;

export const CategoryListStyle = styled.div`
  display: flex;
  
  column-gap: 1rem;
 

  overflow-x: scroll;
  scrollbar-width: 0;
  ::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 280px) {
    column-gap: 0.6rem;
       
      }
`;